<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    d-add(ref="dialogAdd" :customer-id="customerId" :campaign-id="campaignId" @complele="doLoadAdGroups(true)")
    d-copy(ref="dialogCopy" :customer-id="customerId" :ad-group-selecteds="itemSelecteds")

    v-layout(column)
      v-flex.mb-3
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") autorenew
            v-flex
              .headline Ad Groups
              .overline {{ campaignId }}
          v-flex(d-flex justify-end align-center)
            v-btn.mr-2(@click="doLoadAdGroups(true)") Refersh
            v-btn.mr-2(:disabled="!itemSelecteds.length" @click="$refs.dialogCopy.show()") Copy
            v-btn(@click="$refs.dialogAdd.show()") Add Ad Group

      v-flex(fill-height)
        v-card
          v-data-table(
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="15"
            item-key="adGroup.resourceName"
            v-model="itemSelecteds"
            show-select
          )
            template(v-slot:item.action="{ item }")
              v-btn.mx-1(small depressed color="green" :to="goKeyword(item)") Keyword
              v-btn.mx-1(small depressed color="yellow" :to="goAdGroupAd(item)") Ad
</template>

<script>
import { mapActions } from 'vuex'
import DAdd from './dialogs/AddAdGroup'
import DCopy from './dialogs/CopyAdGroup'

export default {
  components: {
    DAdd,
    DCopy
  },
  data () {
    return {
      customerId: null,
      campaignId: null,
      loading: false,
      items: [],
      itemSelecteds: [],
      headers: [
        { text: 'ID', value: 'adGroup.id' },
        { text: 'Name', value: 'adGroup.name' },
        { text: 'Status', value: 'adGroup.status' },
        { text: 'Type', value: 'adGroup.type' },
        { text: '', value: 'action' }
      ]
    }
  },
  async mounted () {
    this.customerId = this.$route.params.customer
    this.campaignId = this.$route.params.campaign
    this.doLoadAdGroups()
  },
  methods: {
    ...mapActions({
      loadAdGroups: 'ads/loadAdGroups'
    }),
    async doLoadAdGroups (reload = false) {
      if (this.customerId && this.campaignId) {
        const params = {
          customerId: this.customerId,
          campaignId: this.campaignId,
          reload: reload
        }
        this.loading = true
        this.items = await this.loadAdGroups(params)
        this.loading = false
      }
    },
    goKeyword (item) {
      const id = item.adGroup.id
      return { name: 'google-ads-ad-group-keyword', params: { customer: this.customerId, campaign: this.campaignId, adgroup: id } }
    },
    goAdGroupAd (item) {
      const id = item.adGroup.id
      return { name: 'google-ads-ad-group-ad', params: { customer: this.customerId, campaign: this.campaignId, adgroup: id } }
    }
  }
}
</script>
